import React, { useEffect } from "react";
import { Alert, Button } from "react-native";
import VStack from "../../ui_atoms/VStack";
import { useIntercom } from "../../hooks/intercom";
import type { StoryObj } from "@storybook/react";
import { KycStatus } from "../../__generated__/graphql";

const StoryComponent = () => {
    const { presentIntercom, presentArticle, updateUser, logout, login } = useIntercom();
    useEffect(() => {
        void login({
            id: "storybook_test",
            intercomUserId: "storybook_test",
            email: "john.doe@example.com",
            // following hmacs are for the user with id "storybook_test"
            // and generated with django command `pipenv run python manage.py intercom_storybook`
            iosIntercomHmac: "1392b65096e35f010e6390ac9753ed9757a4678d95ed14e433fd65d2ab4d0a2c",
            androidIntercomHmac: "e0ddaa8950851c0936a29d5609b09fa25cbebab32e58a1bfc5d165fd09ab6e85",
            kycStatus: {
                status: KycStatus.Accepted,
                veriffUrl: "https://veriff.com",
            },
            clientInfos: [],
            clientProfiles: [],
        }).then(() => {
            return updateUser({ languageOverride: "fr" });
        });
        // void loginUnidentifiedUser();

        return () => {
            void logout();
        };
    }, [updateUser, login, logout]);
    return (
        <VStack gap={0.5} alignment="center" style={{ width: "100%" }}>
            <Button
                onPress={() => {
                    void presentIntercom().then((res) => {
                        if (!res) {
                            Alert.alert(
                                "Intercom not available, check your app is COMPILED " +
                                    "with INTERCOM_APP_ID env variable set",
                            );
                        }
                    });
                }}
                title={"Present Intercom"}
            />
            <Button
                onPress={() => {
                    void presentArticle("CreateMissionEarningType.time_sheets").then((res) => {
                        if (!res) {
                            Alert.alert(
                                "Intercom not available, check your app is COMPILED " +
                                    "with INTERCOM_APP_ID env variable set",
                            );
                        }
                    });
                }}
                title={"Present Article"}
            />
        </VStack>
    );
};

const meta = {
    title: "Components/Intercom",
    component: StoryComponent,
    argTypes: {},
    args: {},
    parameters: {
        sherlo: {
            exclude: true,
        },
    },
};

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
